<template>
  <div class="chat-header">
    <div class="header-content">
      <img
        src="/assets/images/logos_brand/regular/flygresor.se_logo.png"
        alt="Flygresor.se Logo"
        style="height: 24px;"
        :class="{
          'hidden': !isFullScreen,
        }"
      >
      <div
        class="status-indicator"
        :class="{
          'hidden': isFullScreen,
          'disabled': !isEnabled
        }"
      />
      <h2>{{ l('chat.header.title') }}</h2>
      <span class="ai-badge">AI</span>
      <slot name="header-actions" />
    </div>
  </div>
</template>

<script setup>
import { l } from '@utils/toolbox';
const props = defineProps({
	isFullScreen: {
		type: Boolean,
		default: false
	}
});

import { useChatApi } from './useChatApi';
const { isEnabled } = useChatApi();
</script>


<style scoped lang="scss">
.chat-header {
  display: none;
  background: linear-gradient(135deg, $main-btn-bg 0%, $brand-btn-bg 100%);
  padding: 20px 24px;
  border-bottom: 1px solid rgba($white, 0.1);

  @include breakpoint_up(md) {
    display: initial;
  }
}

.header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-indicator {
  width: 8px;
  height: 8px;
  background: $correct-font-color;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba($correct-font-color, 0.2);
  animation: pulse 2s infinite;

  &.disabled {
    background: $warning-font-color;
    box-shadow: 0 0 0 3px rgba($warning-font-color, 0.2);
    animation: none;
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.chat-header h2 {
  margin: 0;
  color: $white;
  font-size: 18px;
  font-weight: 600;
}

.ai-badge {
  display: inline-block;
  padding: 4px 8px;
  background: rgba($white, 0.25);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  color: $white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
